import '../assets/index28.css';var D = Object.defineProperty;
var E = (d, e, a) => e in d ? D(d, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : d[e] = a;
var m = (d, e, a) => (E(d, typeof e != "symbol" ? e + "" : e, a), a);
import { defineComponent as p, mergeModels as A, useModel as S, computed as I, watch as y, onMounted as U, onBeforeUnmount as O, openBlock as u, createBlock as f, Transition as P, withCtx as h, mergeProps as L, withKeys as K, createElementBlock as v, toDisplayString as M, createCommentVNode as g, normalizeClass as w, withModifiers as N, ref as T, Teleport as z, Fragment as $, renderList as B, createVNode as F, TransitionGroup as G, unref as j } from "vue";
import { AdsLink as q } from "../atoms/link/index.js";
import { _ as V } from "./index.99cfd0be.js";
import { AdsMessage as x } from "../molecules/message/index.js";
import { useI18n as H } from "vue-i18n";
const J = {
  key: 0,
  class: "ads-snack-bar__description"
}, Q = ["id"], R = {
  key: 1,
  class: "ads-snack-bar__description-message"
}, W = /* @__PURE__ */ p({
  name: "AdsSnackBar",
  __name: "index",
  props: /* @__PURE__ */ A({
    message: {},
    asChild: { type: Boolean },
    as: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ A(["close", "action-clicked"], ["update:modelValue"]),
  setup(d, { emit: e }) {
    const a = e, t = S(d, "modelValue"), { t: s } = H();
    let i;
    const l = I(() => d.message.title ? { "aria-labelledby": `messageTitle-${d.message.id}` } : { "aria-label": s("ads.snack-bar.modal-dialog-box") }), o = () => {
      i && (clearTimeout(i), i = void 0);
    }, r = () => {
      o(), t.value = !1, a("close", d.message.id);
    }, c = (n) => {
      a("action-clicked", n);
    }, C = () => {
      o(), t.value && d.message.autoDismiss && d.message.autoDismiss > 0 && (i = setTimeout(() => {
        r();
      }, d.message.autoDismiss));
    };
    return y(() => t.value, (n) => {
      n ? C() : o();
    }, { immediate: !0 }), y(() => d.message, () => {
      t.value && C();
    }, { deep: !0 }), U(() => {
      t.value && C();
    }), O(() => {
      o();
    }), (n, b) => (u(), f(P, {
      name: "fade-slide-vertical",
      appear: ""
    }, {
      default: h(() => [
        t.value ? (u(), f(V, L({ key: 0 }, {
          as: n.as,
          asChild: n.asChild
        }, { class: "ads-snack-bar" }), {
          default: h(() => [
            (u(), f(x, L({
              key: n.message.id,
              "is-visible": t.value,
              "onUpdate:isVisible": b[1] || (b[1] = (_) => t.value = _),
              variation: n.message.variation,
              icon: n.message.icon,
              border: n.message.border,
              closable: "",
              role: "dialog"
            }, l.value, {
              "aria-modal": "true",
              "aria-live": "assertive",
              tabindex: "-1",
              onKeydown: K(r, ["esc"]),
              onClose: r
            }), {
              default: h(() => [
                n.message.title || n.message.message ? (u(), v("div", J, [
                  n.message.title ? (u(), v("p", {
                    key: 0,
                    id: `messageTitle-${n.message.id}`,
                    class: "ads-snack-bar__description-title"
                  }, M(n.message.title), 9, Q)) : g("", !0),
                  n.message.message ? (u(), v("p", R, M(n.message.message), 1)) : g("", !0)
                ])) : g("", !0),
                n.message.actionLabel ? (u(), f(q, {
                  key: 1,
                  as: "button",
                  type: "button",
                  class: w(["ads-snack-bar__action-cta", { "ads-snack-bar__action-cta--light": n.message.variation === "default" }]),
                  text: n.message.actionLabel,
                  onClick: b[0] || (b[0] = N((_) => c(n.message), ["prevent"]))
                }, null, 8, ["class", "text"])) : g("", !0)
              ]),
              _: 1
            }, 16, ["is-visible", "variation", "icon", "border"]))
          ]),
          _: 1
        }, 16)) : g("", !0)
      ]),
      _: 1
    }));
  }
});
class X {
  constructor() {
    m(this, "messageIdCounter", 0);
    m(this, "messages", T(/* @__PURE__ */ new Map([
      ["top-left", []],
      ["top-center", []],
      ["top-right", []],
      ["bottom-left", []],
      ["bottom-center", []],
      ["bottom-right", []]
    ])));
    m(this, "defaultPosition", "bottom-center");
    m(this, "defaultAutoDismiss", 3e3);
    m(this, "closeListeners", []);
    m(this, "actionListeners", []);
  }
  addCloseListener(e) {
    this.closeListeners.push(e);
  }
  removeCloseListener(e) {
    const a = this.closeListeners.indexOf(e);
    a !== -1 && this.closeListeners.splice(a, 1);
  }
  addActionListener(e) {
    this.actionListeners.push(e);
  }
  removeActionListener(e) {
    const a = this.actionListeners.indexOf(e);
    a !== -1 && this.actionListeners.splice(a, 1);
  }
  add(e, a, t, s) {
    const i = (s == null ? void 0 : s.position) || this.defaultPosition, o = {
      id: this.messageIdCounter++,
      variation: e,
      title: a,
      message: t,
      icon: s == null ? void 0 : s.icon,
      border: s == null ? void 0 : s.border,
      autoDismiss: (s == null ? void 0 : s.autoDismiss) ?? this.defaultAutoDismiss,
      actionLabel: s == null ? void 0 : s.actionLabel,
      onClose: s == null ? void 0 : s.onClose,
      onAction: s == null ? void 0 : s.onAction
    }, r = this.messages.value.get(i) || [];
    r.push(o), this.messages.value.set(i, [...r]);
  }
  remove(e, a) {
    var t;
    if (a) {
      const s = this.messages.value.get(a);
      if (s) {
        const i = s.findIndex((l) => l.id === e);
        if (i !== -1) {
          const l = s[i];
          (t = l.onClose) == null || t.call(l, e), s.splice(i, 1), this.messages.value.set(a, [...s]), this.closeListeners.forEach((o) => o(e));
        }
      }
    } else
      this.messages.value.forEach((s, i) => {
        var o;
        const l = s.findIndex((r) => r.id === e);
        if (l !== -1) {
          const r = s[l];
          (o = r.onClose) == null || o.call(r, e), s.splice(l, 1), this.messages.value.set(i, [...s]), this.closeListeners.forEach((c) => c(e));
        }
      });
  }
  handleAction(e) {
    var a;
    (a = e.onAction) == null || a.call(e, e), this.actionListeners.forEach((t) => t(e));
  }
  removeAll() {
    this.messages.value.forEach((e, a) => {
      e.forEach((t) => {
        var s;
        return (s = t.onClose) == null ? void 0 : s.call(t, t.id);
      }), this.messages.value.set(a, []);
    });
  }
  success(e, a, t) {
    this.add("success", e, a, t);
  }
  warning(e, a, t) {
    this.add("warning", e, a, t);
  }
  danger(e, a, t) {
    this.add("danger", e, a, t);
  }
  default(e, a, t) {
    this.add("default", e, a, t);
  }
}
const k = new X(), ie = /* @__PURE__ */ p({
  name: "AdsSnackBarContainer",
  __name: "SnackBarContainer",
  props: {
    teleportTo: { default: "body" },
    asChild: { type: Boolean },
    as: {}
  },
  setup(d) {
    const e = [
      "top-left",
      "top-center",
      "top-right",
      "bottom-left",
      "bottom-center",
      "bottom-right"
    ], a = T({}), t = (i, l) => {
      i !== void 0 && k.remove(i, l);
    }, s = (i) => {
      k.handleAction(i);
    };
    return y(() => k.messages.value, (i) => {
      e.forEach((l) => {
        (i.get(l) || []).forEach((r) => {
          const c = `${l}-${r.id}`;
          a.value[c] || (a.value[c] = !0);
        });
      });
    }, { deep: !0 }), (i, l) => (u(), f(V, L({ as: i.as, asChild: i.asChild }, { class: "ads-snack-bar-container" }), {
      default: h(() => [
        (u(), f(z, { to: i.teleportTo }, [
          (u(), v($, null, B(e, (o) => F(G, {
            key: o,
            name: "fade-slide-height",
            tag: "div",
            class: w(["ads-snack-bar-container__position", [`ads-snack-bar-container__position--${o}`]])
          }, {
            default: h(() => [
              (u(!0), v($, null, B(j(k).messages.value.get(o), (r) => (u(), f(W, {
                key: r.id,
                modelValue: a.value[`${o}-${r.id}`],
                "onUpdate:modelValue": (c) => a.value[`${o}-${r.id}`] = c,
                message: r,
                onClose: (c) => t(c, o),
                onActionClicked: l[0] || (l[0] = (c) => s(c))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "message", "onClose"]))), 128))
            ]),
            _: 2
          }, 1032, ["class"])), 64))
        ], 8, ["to"]))
      ]),
      _: 1
    }, 16));
  }
});
export {
  W as _,
  ie as a,
  k as s
};
